import { FC } from 'react';
import { Box, Alert, AlertIcon, AlertTitle, AlertDescription, Button } from '@chakra-ui/react';

type Props = {
  title: string;
  description: string;
  onClick?: Function;
  isProcessing?: boolean;
}

export const AlertBanner: FC<Props> = ({title, description, onClick, isProcessing}) => (
  <Alert status="error" className="alert--banner">
    <AlertIcon />
    <Box flex="1">
      <AlertTitle>
        {title}
      </AlertTitle>
      <AlertDescription display="block">
        {description}
      </AlertDescription>
    </Box>
    {onClick && (
      <Button className="button--alert-undo" variant="ghost" onClick={() => onClick()} isLoading={isProcessing}>
        Undo
      </Button>
    )}
  </Alert>
);